import { render, staticRenderFns } from "./EditAdmin.vue?vue&type=template&id=40f3e741"
import script from "./EditAdmin.vue?vue&type=script&lang=js"
export * from "./EditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports